import { MixPanelFilters } from '../../interfaces/analytics.interface';
import { FilterParam } from '../../interfaces/elastic-query.interface';

export function getAllSelectedFilters(data: FilterParam): MixPanelFilters{
  const allSelectedFilters: MixPanelFilters = {};

  Object.keys(data).forEach((key: string) => {
    let selectedKey: string = 'Filter_' + key;
    selectedKey = capitalizeFirstLetter(selectedKey.split('_'));
    allSelectedFilters[selectedKey] = data[key];
  });
  return allSelectedFilters;
}

export function capitalizeFirstLetter(stringArray: string[]): string {
  const str: string[] = [];
  stringArray.forEach((key) => {
    str.push(key.charAt(0).toUpperCase() + key.slice(1));
  });
  return str.join('_');
}
